import config from "../../config/config";
import connection from "../../utils/connection";

export default async function getMisNotificaciones() {
    let response = {};

    try {
        const responseGet = await connection({
            method: "GET",
            url: "/notificaciones/getMisNotificaciones",
        });
        if (responseGet.status === 401) return (window.location.href = `${config.URL.STOP_APP_URL}/login`);
        response = responseGet.data;
    } catch (error) {
        console.error("catch service", error);
        response = error.response;
    }

    return response;
}
